import type * as React from "react"

import CheckCircle from "@/assets/svg/check-circle.svg?react"
import CrossCircle from "@/assets/svg/cross-circle.svg?react"
import ExclamationCircle from "@/assets/svg/exclamation-circle.svg?react"
import InfoCircle from "@/assets/svg/info-circle.svg?react"
import { Badge } from "@/components/ui/badge"
import { cn } from "@/lib/utils"

const Variants = {
  success: {
    style: "border-[#B4E481] bg-[#C8FD8F]",
    label: "Clarity",
    icon: CheckCircle,
  },
  warning: {
    style: "border-[#E5C5A1] bg-[#FFDBB3]",
    label: "Clarity",
    icon: ExclamationCircle,
  },
  caution: {
    style: "border-[#E5D67D] bg-[#FFEE8B]",
    label: "Clarity",
    icon: InfoCircle,
  },
  critical: {
    style: "border-[#E5B8B3] bg-[#FFCCC7]",
    label: "Clarity",
    icon: CrossCircle,
  },
}

interface PromptBadgeProps {
  variant: keyof typeof Variants
  children?: React.ReactNode
}

export const PromptBadge = ({ variant, children }: PromptBadgeProps) => {
  const Icon = Variants[variant].icon
  return (
    <Badge
      className={cn(
        "rounded-full border-solid px-2 py-1 text-sm leading-4 text-black/50 [&>svg]:size-4",
        Variants[variant].style,
      )}
    >
      {children ?? (
        <>
          <Icon />
          {Variants[variant].label}
        </>
      )}
    </Badge>
  )
}
